import axiosPost from "./axiosPost";

export const RNHHospitalUpd = async (credentials, data) => {
    const body = {
        service: "RNHHospitalUpd",
        params: {
            rnhHospitalId: data?.id,
            rnhHospitalCod: data?.cod,
            rnhHospitalNombre: data?.nombre,
            rnhNivelId: data?.nivelId,
            rnhAreaId: data?.areaId,
            rnhHospitalCabecera: data?.cabecera,
            rnhHospitalCalle: data?.calle,
            rnhHospitalNumero: data?.numero,
            rnhHospitalPiso: data?.piso,
            rnhUnidadId: data?.unidad,
            localidadId: data?.localidadId,
            rnhHospitalLatitud: data?.lat,
            rnhHospitalLongitud: data?.lng,
            rnhHospitalVersion: data?.version,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
